/**
 * Controls the maximum value that the proximity operator
 * can have before we display an error.
 *
 * Example FTS queries with a proximity operator:
 * - `"hello world"~4` - OK
 * - `"whats up dog"~6` - ERROR
 */
export const SAID_WITHIN_MAX = 5;
